import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const voiceSlider = () => {
    const el = document.querySelector('.js-voice_swiper');
    if (!el) return;

    new Swiper(el, {
        modules: [Pagination, Navigation, Autoplay],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.js-voice_pagination',
            clickable: true,
        },
        navigation: {
            prevEl: '.js-voice_nav-prev',
            nextEl: '.js-voice_nav-next',
        },
        breakpoints: {
            // SP
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                centeredSlides: true,
            },
            // PC
            769: {
                slidesPerView: 'auto',
                spaceBetween: 40,
                centeredSlides: false,
            },
        },
    });
};

export default voiceSlider;
